
//
// Commissions Page Controller
//

module.exports = function CommissionsController ($page, $$) {


  // Find widgets

  var livePrice  = getWidgetAt($$('[data-widget="live-price"]'));
  var selectors  = $$('[data-widget="box-selector"]').toArray().map(getWidgetAt);
  var autofields = $$('[data-widget="autofield"]').toArray().map(getWidgetAt);


  // Live cost estimate

  var priceData = PHP_PRICE_DATA;
  var selection = { size: null, detail: null, delivery: null, };

  function updatePrice () {
    var price = 0;

    var size     = selection.size     ? selection.size     : priceData.size.default;
    var detail   = selection.detail   ? selection.detail   : priceData.detail.default;
    var delivery = selection.delivery ? selection.delivery : priceData.delivery.default;

    log("CommissionController::updatePrice - selection updated:", size, detail, delivery);

    price += priceData.size[size];
    price += priceData.detail[detail][size];
    price += priceData.delivery[delivery][size];

    livePrice.setValue(price);
  }

  selectors.map(function (selector) {
    selector.onChange(function (value, key) {
      selection[selector.name] = key;
      updatePrice();
    });
  });


  // Wire autofields together

  selectors.map(function (selector) {
    selector.onChange(function (value) {
      autofields.filter(function (field) {
        return field.name === selector.name
      })[0].setValue(value);
    })
  });


  // Init

  updatePrice();


  // Debug

  /*
  $('[name=name]').val('Jordan');
  $('[name=email]').val('jordan@ghost.st');
  */
}

